/**
 *
 * BackgroundStripped
 *
 */

import PropTypes from 'prop-types';
import React from 'react';
import WaveIcon from '../WaveIcon';
// import styled from 'styled-components';

function BackgroundStripped(props) {
  const { isMembershipPage } = props;
  return (
    <div>
      {props.children && (
        <div
          className={`subhdr-stripes subhdr-stripes--ucase ${!isMembershipPage &&
            'hide-phone'} subhdr-stripes--sub about-story__wrap`}
        >
          {props.children}
        </div>
      )}
      {props.mobileType2 && (
        <div className="footerDiferDiv phone-only">
          <WaveIcon>
            <h1 className="footerDiferrence">{props.mobileTitle}</h1>
          </WaveIcon>
        </div>
      )}
      {props.mobileTitle &&
        !props.mobileType2 && (
          <div className="subhdr-stripes subhdr-stripes--ucase mobileBackStrippedText phone-only">
            {props.mobileTitle}
          </div>
        )}
      {props.mobileDom && (
        <div className="subhdr-stripes subhdr-stripes--ucase mobileBackStrippedText phone-only">
          {props.mobileDom}
        </div>
      )}
    </div>
  );
}

BackgroundStripped.propTypes = {
  children: PropTypes.node,
  mobileTitle: PropTypes.string,
  mobileDom: PropTypes.node,
  mobileType2: PropTypes.bool,
  isMembershipPage: PropTypes.bool,
};

export default BackgroundStripped;
